export enum Role {
  superAdmin = 1,
  admin=2,
  clinician=3,
  researcher=4,
  patient=5
}
